export const isRedisSessionEnabled = () => window.REACT_APP_USE_REDIS_SESSION?.trim().toLowerCase() === 'true';

function getSessionManagerHostUrl() {
  return (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_SESSION_MANAGER_HOST)
    || (isRedisSessionEnabled() && window.REACT_APP_SESSION_MANAGER_HOST_REDIS
      ? window.REACT_APP_SESSION_MANAGER_HOST_REDIS
      : window.REACT_APP_SESSION_MANAGER_HOST);
}

function getDeviceManagerHostUrl() {
  return (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_DEVICE_MANAGER_HOST)
    || (isRedisSessionEnabled() && window.REACT_APP_DEVICE_MANAGER_HOST_REDIS
      ? window.REACT_APP_DEVICE_MANAGER_HOST_REDIS
      : window.REACT_APP_DEVICE_MANAGER_HOST);
}

function getEventManagerHostUrl() {
  return (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_EVENT_MANAGER_HOST)
    || (isRedisSessionEnabled() && window.REACT_APP_EVENT_MANAGER_HOST_REDIS
      ? window.REACT_APP_EVENT_MANAGER_HOST_REDIS
      : window.REACT_APP_EVENT_MANAGER_HOST);
}

function getTscoreBaseUrl() {
  return window.REACT_APP_DOMAIN_TSCORE_API_URL;
}

function getSfManagerHostUrl() {
  return (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_SF_MANAGER_HOST)
    || (isRedisSessionEnabled() && window.REACT_APP_SF_MANAGER_HOST_REDIS
      ? window.REACT_APP_SF_MANAGER_HOST_REDIS
      : window.REACT_APP_SF_MANAGER_HOST);
}

export function getTokenV1EndPoint() {
  return getSessionManagerHostUrl() + "/api/ts/v1/oauth2/token";
}

export function tsV1LoginEndPoint() {
  return getSessionManagerHostUrl() + "/api/v1/sasp/login";
}

export function validateTokenEndpoint() {
  return getSessionManagerHostUrl() + "/api/v1/sasp/oauth2/token/validate";
}

//OIDC end-point validation call - JWT validation
export function validateJWTEndpoint() {
  return getSessionManagerHostUrl() + "/api/v1/vision/oidc/token/validate";
}

export function invalidateTokenEndpoint() {
  return getSessionManagerHostUrl() + "/api/v1/vision/logout";
}

export function tscoreLogoutEndpoint() {
  return getTscoreBaseUrl() + "/oidc/v1/logout";
}

export function fetchV1DeviceEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/sasp/devices/action/query";
}
export function fetchV1HistoryEndPoint(field) {
  return getDeviceManagerHostUrl() + "/api/v1/sasp/device/history/" + field;
}
export function fetchCameraReportData() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/cameras/fields/history";
}
export function fetchCameraReportDataForCvApp(cvApp) {
  return (
    getDeviceManagerHostUrl() +
    "/api/v1/vision/cameras/fields/" +
    cvApp +
    "/history"
  );
}
export function fetchCameraReportDataAggregated() {
  return (
    getDeviceManagerHostUrl() +
    "/api/v1/vision/cameras/fields/history/aggregated"
  );
}
export function fetchCameraReportDataForEEAppAggregated() {
  return (
    getDeviceManagerHostUrl() +
    "/api/v1/vision/cameras/fields/GetPeopleCountHistoryAggreagte"
  );
}
export function getStatisticsAggegateCountsEndPoint() {
  return (
    getDeviceManagerHostUrl() +
    "/api/v1/vision/cameras/fields/GetAggreagtedCountForApps"
  );
}
export function fetchv1DeviceDetailsEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/sasp/devices/action/query/detail";
}
export function setDeviceNameEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/sasp/devices/action/update";
}
export function activateSensorEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/sasp/devices/sensors/activate";
}
export function fetchGatewaysListEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/sasp/devices/gateways";
}
export function fetchSensorsListEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/sasp/devices/sensors";
}
export function createRuleEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/rules/create";
}
export function fetchRulesEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/rules/fetch";
}
export function fetchSmartAlertsEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/smartAlerts/fetch";
}
export function updateSmartAlertEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/smartAlerts/update";
}
export function deleteRuleEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/rules/delete";
}
export function editRuleEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/rules/update";
}

//Vision APIs

export function getInviteUserLoginEndPoint() {
  return getSessionManagerHostUrl() + "/api/v1/vision/login";
}

export function sendInviteEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/mobile/users/sendInvite";
}

export function getAccountDetails() {
  return getSessionManagerHostUrl() + "/api/v1/vision/accountDetails";
}

export function getBillingAccounts() {
  return getSessionManagerHostUrl() + "/api/v1/vision/billingAccounts";
}

export function getUsersList() {
  return getSessionManagerHostUrl() + "/api/v1/vision/billingAccount/usersList";
}

export function addBillingAccountUser() {
  return getSessionManagerHostUrl() + "/billingAccount/user/actions/add";
}

export function removeBillingAccountUser() {
  return (
    getSessionManagerHostUrl() +
    "/api/v1/vision/billingAccount/user/actions/remove"
  );
}

export function createandgetTagEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/devices/get/tags";
}

export function deleteTagEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/delete/tags";
}
export function createNewandGetTagEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/create/tags";
}
export function createNewSiteLabelEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/visionSites/create/siteLevels";
}
export function deleteSiteLabelEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/visionSites/delete/siteLevels";
}
export function updateSiteLabelEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/visionSites/update/siteLevels";
}

export function addTagToDeviceEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/apply/device/tags";
}

export function patchTagEndpoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/patch/tags";
}

export function updateCameraCredentialsOnCCD() {
  return (
    getDeviceManagerHostUrl() +
    "/api/v1/vision/devices/update/cameracredentials"
  );
}

export function getCameraCredsEndPoint() {
  return (
    getDeviceManagerHostUrl() +
    "/api/v1/vision/devices/get/cameraCreds"
  );
}

export function getTagHierarchyEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/tags/getHierarchy";
}

export function deleteTagHierarchyEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/tags/deleteHierarchy";
}

export function createTagHierarchyEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/tags/createHierarchy";
}

export function editTagEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/edit/tags";
}
// Add Site to created group
export function addSiteToGroupEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/tags/groups/associate/users"
  );
}
export function fetchVisionDevicesEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/devices/action/query/detail"
  );
}

export function fetchCompanionDeviceEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/devices/companions";
}
//pending
export function fetchCameraDevicesEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/devices/cameras";
}

export function updateonboardedEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/devices/camera/updateonboarded"
  );
}

export function updateManualOnboardedEndPoint() {
  return (
    getDeviceManagerHostUrl() +
    "/api/v1/vision/devices/companions/pairingCandidates"
  );
}

export function fetchCameraAndFovsForRbacEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/devices/get/getcamerafovcvapp"
  );
}

//Fetch candidate cameras of a companion device
export function fetchDiscoveredCamerasEndPointByCompanion() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/devices/companion/candidates"
  );
}

export function forceDiscoveryAPI() {
  return (
    getDeviceManagerHostUrl() +
    "/api/v1/vision/devices/companion/candidates/forceDiscovery"
  );
}

//Fetch candidate cameras of a companion device
export function fetchDiscoveredCamerasEndPointByCamera() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/devices/camera/candidates";
}

//Pair a camera to a companion device
export function pairCameraEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/devices/camera/pair";
}

//Unpair a camera from a companion device
export function unpairCameraEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/devices/camera/unpair";
}

//Start live stream on a camera
export function startLiveStreamEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/devices/camera/stream/start"
  );
}

//Stop live stream on a camera
export function stopLiveStreamEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/devices/camera/stream/stop"
  );
}

//Camera relative PTZ control
export function ptzRelativeControlEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/devices/camera/ptz/relative"
  );
}

//Camera absolute PTZ control
export function ptzAbsoluteControlEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/devices/camera/ptz/absolute"
  );
}

//Camera set home position
export function setHomePositionEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/devices/camera/ptz/sethome"
  );
}

//Camera go to home position
export function goToHomePositionEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/devices/camera/ptz/gohome";
}

export function fetchIncidentsEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/incidents/fetch";
}

//To resolve bulk events
export function resolveBulkEventsEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/incidents/resolveBulk";
}

//To check bulk resolve status
export function checkResolveBulkStatusEndPoint() {
  return getEventManagerHostUrl() + `/api/v1/vision/incidents/resolveBulk/status`;
}

export function updateIncidentStatusEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/incidents/update";
}

export function fetchIncidentsByFloorStatsEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/incidents/site/floor/stats";
}

export function fetchEvidenceDetailsEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/evidence/fetch";
}

export function fetchEvidenceS3UrlEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/evidence/fetch/s3url";
}


export function enableEvidenceStatesEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/companion/enableEdiventState"
  );
}

export function disableEvidenceStatesEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/companion/disableEdiventState"
  );
}

export function getEvidenceStatesEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/companion/getEdiventState";
}

//To fetch all CV Apps available in the account
export function fetchCVApplicationEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/cvapplications/fetch";
}

//To create ROI api
export function createRoiEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/rois/create";
}

//To update ROI api
export function updateRoiEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/rois/update";
}

//To Delete ROI api
export function deleteRoiEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/rois/delete";
}

//List ROIs by cameraId/FovId
export function listRoiEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/rois/list";
}

//Deploy ROIs
export function DeployRoiEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/rois/deploy";
}

//Update Deploy ROIs
export function UpdateDeployRoiEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/rois/updatedeploy";
}

//To create CV Apps api
export function createCVApplicationEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/cvapplications/create";
}

//To provision a CV App to the account -- TODO: Do we support this from portal?
export function provisionCVApplicationEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/cvapplications/provision";
}

//To update a CV App on the account
export function updateCVApplicationEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/cvapplications/update";
}

//To delete a CV App from the account
export function deleteCVApplicationEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/cvapplications/delete";
}

//To Fetch CV App deployment Location details
export function fetchCVApplicationLocationEndPoint() {
  return (
    getDeviceManagerHostUrl() +
    "/api/v1/vision/cvapplications/getroislocationsbycvapp"
  );
}

//To fetch all CV Apps running on a companion device
export function fetchCompanionCVApplicationEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/cvapplications/companion/fetch"
  );
}

//To deploy a CV App on a companion device
export function deployCompanionCVApplicationEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/cvapplications/companion/deploy"
  );
}

//To remove a CV App from a companion device
export function removeCompanionCVApplicationEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/cvapplications/companion/remove"
  );
}

//To bulk unscubrscribe CV Apps from a companion device
export function bulkUnsubscribeCVApps() {
  return (
    getDeviceManagerHostUrl() +
    "/api/v1/vision/cvapplications/actions/bulkundeploy"
  );
}

//To query CV app subscriptions on a camera
export function queryCameraCVApplicationEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/cvapplications/camera/query"
  );
}

//To subscribe to a CV App on a camera
export function subscribeCameraCVApplicationEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/cvapplications/camera/subscribe"
  );
}

//Unsubscribe a CV App from a camera
export function unsubscribeCameraCVApplicationEndPoint() {
  return (
    getDeviceManagerHostUrl() +
    "/api/v1/vision/cvapplications/camera/unsubscribe"
  );
}

//To fetch all Locations based on a CVApp
export function fetchROILocationsByCVAppEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/cvapplications/locations/fetch"
  );
}

//User groups APIs
export function fetchNotificationGroupsEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/notification/groups/query";
}

export function createNotificationGroupsEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/notification/groups/create";
}

export function updateNotificationGroupsEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/notification/groups/update";
}
export function deleteNotificationGroupsEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/notification/groups/delete";
}

export function addUsersToNotificationGroupsEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/notification/groups/addUsers";
}

export function removeUsersToNotificationGroupsEndPoint() {
  return (
    getEventManagerHostUrl() + "/api/v1/sasp/notification/groups/removeUsers"
  );
}

export function fetchNotificationUsersEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/notification/users/query";
}
export function createNotificationUsersEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/notification/users/create";
}
export function updateNotificationUsersEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/notification/users/update";
}

export const updateMdnNotificationUsersEndPoint = () => {
  return getEventManagerHostUrl() + "/api/v1/vision/users/phonenumber/actions/requestchange";
};

export const updateOtpNotificationUsersEndPoint = () => {
  return getEventManagerHostUrl() + "/api/v1/vision/users/phonenumber/actions/change";
};

export const getAccountFeaturesEndpoint = () => {
  return getEventManagerHostUrl() + "/api/v1/vision/users/accountFeatures";
};

export function getAllInviteesEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/mobile/users/getAllInvitees";
}

export function cancelInvitationEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/mobile/users/cancelInvitation";
}

export function deleteNotificationUsersEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/notification/users/delete";
}
//Create rule for the camera cvapp
export function createVisionRuleEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/rules/create";
}

export function fetchVisionRulesEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/rules/fetch";
}

export function deleteVisionRuleEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/rules/delete";
}

export function updateVisionRuleEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/rules/update";
}

export function bulkDeleteVisionRuleEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/rules/bulkDelete";
}


export function enabledisableVisionRuleEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/rules/toggle";
}

export function auditQueryEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/audit/actions/query";
}

export function uploadMediaEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/upload/image";
}

export function deleteMediaEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/delete/image";
}

export function downloadMediaEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/download/image";
}

export function removeSiteToGroupEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/tags/users/remove";
}
//Knowi
export function getKnowiWidgetsEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/sasp/knowi/widgets";
}
export function getKnowiHashEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/sasp/knowi/widgets/fields/encrypt"
  );
}
export function getWidgetMatrixDataEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/cameras/fields/GetEventMatrixSum"
  );
}

export function getCrowdDensityDatamatrixWidgetEndPoint(){
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/cameras/fields/GetMatrixForCrowdDensity"
  );
}
export function getCrowdDensityDataEndPoint(){
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/visionStats/historyAggregated/CrowdCounting"
  );
}
export function getStatOpenAreaMaxAvgEndPoint(){
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/visionStats/historyAggregated/StatOpenAreaMaxAvg"
  );
}
export function getDwellTimeDataEndPoint(){
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/visionStats/historyAggregated/DwellTime"
  );
}

export function getParkingOccupancyDatamatrixWidgetEndPoint(){
  return (getDeviceManagerHostUrl() + "/api/v1/vision/cameras/fields/GetMatrixForParkingOccupancy");
}
export function getEntryExitWidgetEndPoint(){
  return (getDeviceManagerHostUrl() + "/api/v1/vision/visionStats/historyAggregated/EntryExits");
}


export function getParkingOccupancyOADatamatrixWidgetEndPoint(){
  return (getDeviceManagerHostUrl() + "/api/v1/vision/cameras/fields/GetMatrixForParkingOccupancyOA");
}
export function getInOutCountForEEAppsDatamatrixWidgetEndPoint(){
  return (getDeviceManagerHostUrl() + "/api/v1/vision/cameras/fields/GetInOutCountForEEApps");
}


export function setForceResetBaseLineCountEndPoint() {
  return (
    getDeviceManagerHostUrl() +
    "/api/v1/vision/tags/fields/ForceResetBaselineCount"
  );
}

export function setBaseLineCountEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/tags/fields/setBaselineCount"
  );
}

export function setAllBaseLineCountEndPoint() {
  return (
    getDeviceManagerHostUrl() +
    "/api/v1/vision/tags/fields/getAllScheduledTriggers"
  );
}

//Activitylog api
export function getActivityLogEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/incidents/activitylog";
}
//FilterEvents api
export function filterEventsEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/incidents/actions/query";
}

export function getRoleList() {
  return getSessionManagerHostUrl() + "/api/v1/vision/roles/actions/query";
}

export function createRoleEndPoint() {
  return getSessionManagerHostUrl() + "/api/v1/vision/role/create";
}

export function editRoleTemplate() {
  return getSessionManagerHostUrl() + "/api/v1/vision/roles/actions/expand";
}

export function saveRoleTemplate() {
  return (
    getSessionManagerHostUrl() +
    "/api/v1/vision/roles/requestdefinitions/actions/add"
  );
}

export function deleteRoleRequestDefinition() {
  return (
    getSessionManagerHostUrl() +
    "/api/v1/vision/roles/requestdefinitions/actions/remove"
  );
}

export function updateRoleInfo() {
  return getSessionManagerHostUrl() + "/api/v1/vision/roles";
}

export function fetchRoleRequestDefinition() {
  return getSessionManagerHostUrl() + "/api/v1/vision/roles/requestdefinitions";
}

export function deleteRoleEndPoint() {
  return getSessionManagerHostUrl() + "/api/v1/vision/role/delete";
}

export function fetchRulesByDeviceIdEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/rules/fetch";
}

export function fetchRoleByUser() {
  return getSessionManagerHostUrl() + "/api/v1/vision/roles/query/userRole";
}

export function acceptInviteEndPoint() {
  return getSessionManagerHostUrl() + "/api/v1/vision/users/accept/invite";
}

//License Management APIs
export function fetchLicensesForAccount() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/license/licenseQuery";
}

export function changeLicenseType() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/license/switchLicense";
}

export function removeLicense() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/license/removeLicense";
}

export function listFovByLicenseEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/license/fetchFov";
}

export function suspendLicenseEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/license/suspendLicense";
}

export function resumeLicenseEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/license/resumeLicense";
}

export function resetPasswordEndPoint() {
  return getSessionManagerHostUrl() + "/api/v1/vision/users/resetpassword";
}

export function forgotPasswordEndPoint() {
  return (
    getSessionManagerHostUrl() + "/api/v1/vision/users/password/requestrecovery"
  );
}

export function getUnpairedSnapshotEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/devices/get/unpairedsnapshot"
  );
}

export function getPairedSnapshotEndPoint() {
  return (
    getDeviceManagerHostUrl() + "/api/v1/vision/devices/get/pairedsnapshot"
  );
}
export function retrieveUserSitesEndPoint() {
  return getSessionManagerHostUrl() + "/api/v1/vision/user/sites/query";
}

export function addUserToGroupsEndPoint() {
  return getSessionManagerHostUrl() + "/api/v1/vision/user/addgroups";
}

export function addRoleEndPoint() {
  return getSessionManagerHostUrl() + "/api/v1/vision/roles/add";
}

export function revokeRoleEndPoint() {
  return getSessionManagerHostUrl() + "/api/v1/vision/roles/revoke";
}

//Caliberate a camera
export function getCameraCalibrateEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/devices/camera/caliberate";
}

export function getDeployConfigEndPoint() {
  return getDeviceManagerHostUrl() + "/api/dm/v1/cvapps/actions/deploy";
}

export function uploadErrorLogs() {
  return getSessionManagerHostUrl() + "/api/v1/vision/uploadlogs";
}

//fetch single incident details
export function fetchSingleIncidentDetailsEndPoint() {
  return getEventManagerHostUrl() + "/api/v1/vision/incident/fetch";
}

// Enrolled Appearance APIs
export function fetchAppearancesEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/appearances/actions/query";
}

export function createAppearanceEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/appearances/actions/create";
}

export function deleteAppearanceEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/appearances/actions/delete";
}

export function downloadAppearanceImageEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/appearances/images/download";
}
export function uploadAppearanceImageEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/appearances/images/upload";
}
export function deleteAppearanceImageEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/appearances/images/remove";
}

export function updateAppearanceEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/appearances/actions/update";
}

export function submitAppearanceEndpoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/appearances/actions/submit";
}

export function enrollAppearanceEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/appearances/actions/enroll";
}

//fetch single incident details
export function fetchStatsDataForEventAppsEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/visionStats/events/getEventAppStatsDetail";
}

// ─── User Customdata Endpoint ─────────────────────────────────────────────────

export function getUserCustomdataEndpoint() {
  return getEventManagerHostUrl() + "/api/v1/sasp/users/customdata";
}

// ─── Cortex Agent / Snowflake Manager Endpoints ──────────────────────────────

export function getSnowflakeSessionEndpoint() {
  return getSfManagerHostUrl() + "/api/v1/snowflake/session";
}

export function getCortexAgentSessionRunEndpoint() {
  return getSfManagerHostUrl() + "/api/v1/cortex/agent/session/run";
}

export function getCortexThreadCreateEndpoint() {
  return getSfManagerHostUrl() + "/api/v1/cortex/agent/thread";
}

export function getStreamProxyEndPoint(streamId, sessionId, authToken) {
  const baseUrl = getEventManagerHostUrl() + "/api/v1/vision/stream-proxy/" + streamId + "/";
  const params = new URLSearchParams();
  if (sessionId) params.append('sessionId', sessionId);
  if (authToken) params.append('auth', authToken);
  const queryString = params.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}

//To fetch all History Search Results requested 
export function createForensicSearchResultsEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/forensicsSearch/actions/createHistorySearchResults";
}

//To fetch all History Search Results requested 
export function deleteForensicSearchResultsEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/forensicsSearch/actions/deleteHistorySearchResults";
}
//To fetch Images from Image Indexes 
export function getImageFromImageIndexForensicSearchResultsEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/forensicsSearch/actions/getResultFromImageIndexes";
}


export function getAssignLicenseEndpoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/serviceSubscription/actions/assignlicense";
}

//To get status of History Search 
export function getForensicSearchStatusEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/forensicsSearch/actions/getHistorySearchStatus";
}

//To get status of History Search 
export function getRecentForensicSearchesEndPoint() {
  return getDeviceManagerHostUrl() + "/api/v1/vision/forensicsSearch/actions/getAllHistorySearches";
}
